<template>
	<div class="container-fluid" id="dvcrud">
		<div class="row">
			<div class="col-md-12">
					<breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
			</div>
			<div class="col-md-12">
				<div id="pnlista" class="card" style="display: none;">
					<div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
						<router-link to="/">
								<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						</router-link>
					</div>
					<div class="card-body" style="padding: 10px;">
						<div class="row">
							<div class="col-sm-4 col-md-2 col-lg-2">
								<label for="cbopfiltro">Filtrar:</label>
								<select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                  <option value="0">Código</option>
                  <option value="1">Nome/Razão Social</option>
                  <option value="2">Fantasia</option>
                  <option value="3">Cnpj/Cpf</option>
                  <option value="4">Insc.Estadual/Rg</option>
                  <option value="6">Telefone(1)</option>
                  <option value="7">Telefone(2)</option>
								</select>
							</div>
							<div class="col-sm-8 col-md-4 col-lg-4">
								<label for="edconteudopesq">Conteúdo da pesquisa:</label>
								<input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
							</div>
							<div class="col-sm-2 col-md-2 col-lg-2">
								<label for="cbqtdreg">Situação:</label>
								<select name="cbSituacao" class="form-control form-control-sm" id="cbSituacao" v-model="psituacao" @change="mtdlimpar_listagem()">
									<option value="0">Ativos</option>
									<option value="1">Inativos</option>
									<option value="2">Todos</option>
								</select>
							</div>														
							<div class="col-6 col-sm-6 col-md-2 col-lg-2">
								<label for="cbqtdreg">Registros:</label>
								<select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
									<option value="10">10</option>
									<option value="20">20</option>
									<option value="30">30</option>
									<option value="40">40</option>
									<option value="50">50</option>
									<option value="99999999999">Todos</option>
								</select>
							</div>
							<div class="col-6 col-sm-6 col-md-2 col-lg-2">
								<button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
							</div>
							<div class="col-md-12" style="margin-top: 10px;">
								<vue-bootstrap4-table
												:rows="lsttransportadoras"
												:columns="columns"
												:config="config"
												:classes="classes">
									<template slot="empty-results">
											<div class="col-md-12 text-center">Sem dados para visualização</div>
									</template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->									
									<template slot="id_f" slot-scope="item">
											{{ item.row.id }}
									</template>
									<template slot="ativo_f" slot-scope="item">
										<span v-if="item.row.ativo === 0" class="badge badge-pill badge-primary">Ativo</span>
										<span v-else class="badge badge-pill badge-danger">Inativo</span>
									</template>
									<template slot="cnpjcpf_f" slot-scope="item">
										{{ formatacpfcnpj(item.row.cnpjcpf) }}
									</template>                   									
									<template slot="opcoes" slot-scope="item">
											<button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
											<button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
									</template>
								</vue-bootstrap4-table>
							</div>
							<div class="col-md-12">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
											Registros
											<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lsttransportadoras.length}}</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="card-footer" style="padding: 10px;">
						<div class="row">
							<div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
								<v-pagination
												v-model="pagina_atual"
												:page-count="pqtd_paginas"
												:classes="bootstrapPaginationClasses">
								</v-pagination>
							</div>
							<div class="col-4 col-sm-4 col-md-2 col-lg-2">
								<button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
							</div>
						</div>
					</div>
				</div>

				<div id="pncadastro" class="card" style="display:none;">
					<div class="card-header"><span>{{itensbc.item2.titulo}}</span>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edid">Código:</label>
								<input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
												maxlength="20" style="text-transform: uppercase;" disabled/>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbtptransp">Tipo de Pessoa:</label>
								<select class="form-control form-control-sm" id="cbtptransp" v-model="vtptransp"
												v-bind:disabled="ativadesativa">
									<option value="0">Física</option>
									<option value="1">Jurídica</option>
								</select>
							</div> 
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbativo">Situação:</label>
								<select class="form-control form-control-sm" id="cbativo" v-model="vativo"
												v-bind:disabled="ativadesativa">
									<option value="0">Ativo</option>
									<option value="1">Inativo</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2" v-if="opcrud === 1"> 
								<label for="eddtcadastro_fk">Dt. Cadastro:</label>
								<input type="text" disabled="disabled"
												class="form-control form-control-sm" id="eddtcadastro_fk">                               
							</div>														
							<div class="col-sm-12 col-md-2 col-lg-2" v-else>
								<label for="eddtcadastro">Dt. Cadastro:</label>
								<date-picker id="eddtcadastro" v-model="vdtcadastro" :config="options" class="form-control form-control-sm" disabled="disabled"></date-picker>
							</div> 
						</div>

						<div class="row">
							<div class="col-sm-12 col-md-6 col-lg-6">
								<label for="edrazao">*Nome/Razão Social:</label>
								<input type="text" v-model="vrazao" v-bind:disabled="ativadesativa"
												class="form-control form-control-sm" id="edrazao" maxlength="50"
												style="text-transform: uppercase;">
							</div>
							<div class="col-sm-12 col-md-6 col-lg-6">
								<label for="edfantasia">*Fantasia:</label>
								<input type="text" v-model="vfantasia" v-bind:disabled="ativadesativa"
												class="form-control form-control-sm" id="edfantasia" maxlength="50"
												style="text-transform: uppercase;">
							</div>													
						</div>

						<div class="row">
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edcep">*Cep:</label>
								<input type="text" v-model="vcep" v-bind:disabled="ativadesativa" v-mask="'#####-###'"
									class="form-control form-control-sm" id="edcep">
							</div>
							<div class="col-sm-12 col-md-8 col-lg-8">
								<label for="edlogradouro">Endereço:</label>
								<input type="text" v-model="vlogradouro" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edlogradouro" maxlength="100"
									style="text-transform: uppercase;">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="ednrendereco">Nº Endereço:</label>
								<input type="text" v-model="vnrendereco" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="ednrendereco" maxlength="20"
									style="text-transform: uppercase;">
							</div>
						</div>

						<div class="row">
							<div class="col-sm-12 col-md-12 col-lg-12">
								<label for="edreferencia">Referência:</label>
								<input type="text" v-model="vreferencia" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edreferencia" maxlength="100"
									style="text-transform: uppercase;">
							</div>
						</div>

						<div class="row">
							<div class="col-sm-12 col-md-6 col-lg-6">
								<label for="cbbairro">*Bairro:</label>
								<select id="cbbairro" v-model="vidbairro" v-bind:disabled="ativadesativa"
										data-placeholder="Selecione uma opção" data-allow-clear="true"
										style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="cbmunicipio">*Município:</label>
								<select id="cbmunicipio" v-model="vidmunicipio"
										v-bind:disabled="ativadesativa"
										data-placeholder="Selecione uma opção" data-allow-clear="true"
										style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbuf">*Estado:</label>
								<select id="cbuf" v-model="viduf" v-bind:disabled="ativadesativa"
										data-placeholder="Selecione a uf" data-allow-clear="true"
										style="width:100%;">
								</select>
							</div>
						</div>

						<div class="row">
							<div class="col-sm-12 col-md-2 col-lg-2" v-if="parseInt(vtptransp) === 0">
								<label for="edcnpjcpf">CPF</label>
								<input type="text" v-model="vcnpjcpf" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edcnpjcpf"
									v-mask="'###.###.###-##'">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2" v-else>
								<label for="edcnpjcpf">CNPJ</label>
								<input type="text" v-model="vcnpjcpf" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edcnpjcpf"
									v-mask="'##.###.###/####-##'">
							</div>							
							<div class="col-sm-12 col-md-2 col-lg-2" v-if="parseInt(vtptransp) === 0">
								<label for="edrginsc">RG:</label>
								<input type="text" v-model="vrginsc" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edrginsc" maxlength="20">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2" v-else>
								<label for="edrginsc">IE:</label>
								<input type="text" v-model="vrginsc" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edrginsc" maxlength="20">
							</div>							
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edinscmun">Insc. Municipal:</label>
								<input type="text" v-model="vinscmun" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edinscmun" maxlength="20">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfundacao">Dt. Fundação:</label>
								<date-picker id="eddtfundacao" v-model="vdtfundacao" :config="options" 
									class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edramoatividade">Ramo atividade:</label>
								<input type="text" v-model="vramoatividade" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edramoatividade" maxlength="50">
							</div>
						</div>

						<div class="row">																												
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edfone1">Fone:</label>
								<input type="text" v-model="vfone1" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edfone1"
									v-mask="['(##) ####-####', '(##) #####-####']">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edfone2">Fone:</label>
								<input type="text" v-model="vfone2" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edfone2"
									v-mask="['(##) ####-####', '(##) #####-####']">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edcelular">Celular:</label>
								<input type="text" v-model="vcelular" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edcelular"
									v-mask="['(##) ####-####', '(##) #####-####']">
							</div>
							<div class="col-sm-12 col-md-6 col-lg-6">
								<label for="edresponsavel">Responsável:</label>
								<input type="text" v-model="vresponsavel" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edresponsavel" maxlength="50">
							</div>
						</div>

						<div class="row">
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edcontato">Contato:</label>
								<input type="text" v-model="vcontato" v-bind:disabled="ativadesativa"
										class="form-control form-control-sm" id="edcontato" maxlength="50"
										style="text-transform: uppercase;">
							</div>																												
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edemail">E-mail:</label>
								<input type="email" v-model="vemail" v-bind:disabled="ativadesativa"
										class="form-control form-control-sm" id="edemail" maxlength="100"
										style="text-transform: lowercase;">
							</div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edsite">Site:</label>
								<input type="text" v-model="vsite" v-bind:disabled="ativadesativa"
										class="form-control form-control-sm" id="edsite" maxlength="100"
										style="text-transform: lowercase;">
							</div>							
						</div>

						<div class="row" style="margin-top: 10px;">
							<div class="col-sm-12 col-md-12 col-lg-12">
								<label for="edobs">Observações:</label>
								<div class="form-group">
									<textarea class="form-control" v-bind:disabled="ativadesativa"
										rows="6" id="edobs" v-model="vobs" style="text-transform: uppercase;"></textarea>
								</div>
							</div>
						</div>
					</div>

					<div class="card-footer">
						<div class="row">
							<div class="col-sm-8">
								<h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
							</div>
							<div class="col-sm-2">
								<button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
												v-bind:disabled="validou" class="btn btn-primary btn-sm"
												style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
								</button>
								<button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
												v-bind:disabled="validou" class="btn btn-primary btn-sm"
												style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
								</button>
								<button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
												v-bind:disabled="validou" class="btn btn-primary btn-sm"
												style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
								</button>
							</div>
							<div class="col-sm-2">
								<button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
										<i class="fa fa-close"></i> Cancelar
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import BreadCrumb from '../components/cmpbreadcrumb.vue'
	import VueBootstrap4Table from 'vue-bootstrap4-table'
	import vPagination from 'vue-plain-pagination'
	import util from '../utilitarios/util.js'

	export default {
		name: 'cadtransportadoras',
		components:{
			VueBootstrap4Table,
			vPagination,
			'breadcrumb' : BreadCrumb
		},
		data: function() {
			return {
				lsttransportadoras    : [],
				pfiltro               :  1,
				pconteudo             : '',
				pqtdregistros         : 10,
				pqtd_paginas          :  1,
				pagina_atual          :  1,
				pqtd_total_registros  :  0,
				psituacao             :  0,

				//variáveis do crud
				opcrud                :  0,
				vid                   : '',
        vativo                :  0,
        vtptransp             :  0,
        vdtcadastro 					: util.DataAtual(true),
        vrazao                : '',
        vfantasia             : '',
				vcep                  : '',
				vlogradouro           : '',
				vnrendereco           : '',
				vreferencia           : '',
				vidbairro             : null,
				vidmunicipio          : null,
				viduf                 : null,
				vcnpjcpf              : '',
        vrginsc               : '',
        vinscmun              : '',
        vdtfundacao           : null,
        vresponsavel          : '',
        vramoatividade        : '',
				vfone1                : '',
				vfone2                : '',
        vcelular              : '',
        vcontato              : '',
        vemail                : '',
        vsite                 : '',
				vobs                  : '',

				options: {
					format              : 'DD/MM/YYYY',
					useCurrent          : false,
					locale              : 'pt-BR'
				},

				//variável para habilitação dos campos
				ativadesativa         : true,

				bootstrapPaginationClasses: {
					ul: 'pagination pagination-sm',
					li: 'page-item',
					liActive: 'active',
					liDisable: 'disabled',
					button: 'page-link'
				},
				itensbc : {
					item1 : {
						titulo : 'TRANSPORTADORAS',
						ativo  : false
					},
					item2 : {
						titulo : '',
						ativo  : false
					}
				},
				columns: [
					{
            label: 'Opções',
            name : 'opcoes',
            row_text_alignment: "text-center",
            column_text_alignment: "text-center",
            row_classes: "def-col-opcoes",
            sort: false
					},
					{
						label: "Código",
						name: "id",
						sort: true,
						slot_name: "id_f",
						row_classes: "def-col-cod",
					},
					{
						label: "Situação",
						name: "ativo",
						initial_sort : true,
						initial_sort_order: 'asc',
						sort: true,
						row_text_alignment: "text-center",
						column_text_alignment: "text-center",
						slot_name: "ativo_f",
						row_classes: "def-col-ativo"
					}, 						
					{
						label: "Razão Social",
						name: "razao",
						initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
						initial_sort_order: 'asc',
						sort: true,
						row_text_alignment: "text-left",
						column_text_alignment: "text-left"
          },
          {
            label: "Fantasia",
            name: "fantasia",
            initial_sort : true,
            initial_sort_order: 'asc',
            sort: true,
            row_text_alignment: "text-left",
            column_text_alignment: "text-left"
          },
          {
            label: "Fone",
            name: "fone1",
            initial_sort : true,
            initial_sort_order: 'asc',
            sort: true,
            row_text_alignment: "text-left",
            column_text_alignment: "text-left",
            row_classes: "def-col-fone"
          },
          {
            label: "Cnpj/Cpj",
            name: "cnpjcpf",
            initial_sort : true,
            initial_sort_order: 'asc',
            sort: true,
            row_text_alignment: "text-left",
            column_text_alignment: "text-left",
            slot_name: "cnpjcpf_f",
            row_classes: "def-col-cnpjcpf"
          }          
				],
				config: {
					pagination: false,
					pagination_info: false,
					card_mode: false,
					global_search: {
							visibility: false,
					},
					show_refresh_button : false,
					show_reset_button : false
				},
				classes: {
					table: "table-bordered table-striped table-sm"
				}
			}
		},
		methods:{
			mtdfiltropesquisa(){
				let rfiltro = '';

				switch (parseInt(this.pfiltro)) {
						case 0:
								rfiltro = this.pconteudo === '' ? '' : ' and t.id='+this.pconteudo;
								break;
						case 1:
								rfiltro = this.pconteudo === '' ? '' : ' and upper(t.razao) like upper(\''+this.pconteudo+'%\')';
								break;
						case 2:
								rfiltro = this.pconteudo === '' ? '' : ' and upper(t.fantasia) like upper(\''+this.pconteudo+'%\')';
								break;  
						case 3:
								rfiltro = this.pconteudo === '' ? '' : ' and upper(t.cnpjcpf) like upper(\''+this.pconteudo+'%\')';
								break; 
						case 4:
								rfiltro = this.pconteudo === '' ? '' : ' and upper(t.rginsc) like upper(\''+this.pconteudo+'%\')';
								break;      
						case 5:
								rfiltro = this.pconteudo === '' ? '' : ' and upper(t.fone1) like upper(\''+this.pconteudo+'%\')';
								break; 
						case 6:
								rfiltro = this.pconteudo === '' ? '' : ' and upper(t.fone2) like upper(\''+this.pconteudo+'%\')';
								break;                                                                                                                                            
				}

				switch (parseInt(this.psituacao)) {
					case 0:
							rfiltro = rfiltro + ' and t.ativo=0';
							break;
					case 1:
							rfiltro = rfiltro + ' and t.ativo=1';
							break;                   
				}
												
				return rfiltro;
			},
			mtdexecutapesquisa(){
				var vself           = this;
				let filtro          = vself.mtdfiltropesquisa();
				this.pagina_atual   = 1;
				let parametros      = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor  : 'qtdregistros'},
					{parametro: 'filtro',       valor  : filtro}
				];
        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtransportadoras.php');
        
				retorno.then(function (response) {
					vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
					let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
					vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
					vself.mtdcarregatransportadoras(1);
				}).catch(function (response) {
					alert('Erro ao consultar registros');
				});
			},
			mtdcarregatransportadoras(ipagina){
				var vself       = this;
				let loader      = this.$loading.show();
				let filtro      = vself.mtdfiltropesquisa();
				let parametros  = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'listagem'},
					{parametro: 'filtro',       valor : filtro},
					{parametro: 'limit',        valor : vself.pqtdregistros},
					{parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)}
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtransportadoras.php');
				retorno.then(function (response) {
					vself.lsttransportadoras = response.data;
					loader.hide();
				}).catch(function (response) {
					vself.lsttransportadoras = [];
					loader.hide();
				});
			},
			resetarDados() {
					util.toTop();

					this.vid                = '';
          this.vativo             =  0;
          this.vtptransp          =  0;
          this.vdtcadastro        = util.DataAtual(true);
          this.vrazao             = '';
          this.vfantasia          = '';
					this.vcep               = '';
					this.vlogradouro        = '';
					this.vnrendereco        = '';
					this.vreferencia        = '';
					this.vidbairro          = null;
					this.vidmunicipio       = null;
					this.viduf              = null;
					this.vcnpjcpf           = '';
          this.vrginsc            = '';
          this.vinscmun           = '';
          this.vdtfundacao        = null;
          this.vresponsavel       = '';
          this.vramoatividade     = '';
					this.vfone1             = '';
					this.vfone2             = '';
          this.vcelular           = '';
          this.vcontato           = '';
					this.vemail             = '';
					this.vsite              = '';
					this.vobs               = '';

					$("#cbbairro").val('').trigger('change');
					$("#cbmunicipio").val('').trigger('change');
					$("#cbuf").val('').trigger('change');
			},
			mtddefault(){
				$('#pnlista').hide();
				this.resetarDados();
				$('#pncadastro').fadeIn(700);
				this.$nextTick(function () {
					if (parseInt(this.opcrud) < 3) {
						$('#cbtptransp').focus();
					} else {
						$('#btgravar').focus();
					}
				});
			},
			mtdpreparacrud(op) {
				let vself    = this;
				vself.opcrud = op;
				vself.mtddefault();
			},
			mtdnovo(){
				if (!util.opcaousuario('002Z.008M.001M', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {
					this.itensbc.item2.titulo = 'INCLUSÃO DE TRANSPORTADORAS';
					this.itensbc.item1.ativo  = true;
					this.itensbc.item2.ativo  = true;
					this.ativadesativa        = false;
					this.mtdpreparacrud(1);
				}
			},
			mtdcancelaredicao(){
				this.itensbc.item1.ativo = false;
				this.itensbc.item2.ativo = false;
				$('#pncadastro').hide();
				$('#pnlista').fadeIn(700);
				$('#edconteudopesq').focus();
				setTimeout(function(){
					util.toTop();
				}, 200);
			},
			mtdlimpar_listagem() {
				this.lsttransportadoras   = [];
				this.pagina_atual         = 1;
				this.filtro               = '';
				this.pqtd_total_registros = 0;
				this.pqtd_paginas         = 0;
			},
			mtdgravar(){
				let vself = this;
				if (parseInt(vself.opcrud) < 3) {
					if (parseInt(vself.vtodasfiliais) === 0) {
					}
				}
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								vself.mtdregistro();
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
								$('#btgravar').focus();
							}
						}
					}
				});
			},
			mtdlocalizaregistro(id){
				var vself       = this;
				let loader      = vself.$loading.show();
				let filtro      = ' and t.id='+id;
				let parametros  = [
					{parametro: 'op',           valor : 'listagem'},
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'filtro',       valor : filtro},
					{parametro: 'limit',        valor : 1},
					{parametro: 'offset',       valor : 0},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtransportadoras.php');
				retorno.then(function (response) {
					loader.hide();
					vself.mtdigualarcampos(response.data[0]);
					if (parseInt(vself.opcrud) < 3){
						$('#cbtptransp').focus();
					}else{
						$('#btgravar').focus();
					}
				}).catch(function (response) {
					loader.hide();
				});
			},
			mtdalterar(item){
				if (!util.opcaousuario('002Z.008M.002M', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {
					this.itensbc.item2.titulo = 'ALTERAÇÃO DE TRANSPORTADORAS';
					this.itensbc.item1.ativo  = true;
					this.itensbc.item2.ativo  = true;
					this.ativadesativa        = false;
					this.mtdpreparacrud(2);
					this.mtdlocalizaregistro(item.id);
				}
			},
			mtdexcluir(item){
				if (!util.opcaousuario('002Z.008M.003M', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {
					this.itensbc.item2.titulo = 'EXCLUSÃO DE TRANSPORTADORAS';
					this.itensbc.item1.ativo  = true;
					this.itensbc.item2.ativo  = true;
					this.ativadesativa        = true;
					this.mtdpreparacrud(3);
					this.mtdlocalizaregistro(item.id);
				}
			},
			mtdigualarcampos(registro){
				this.vid                 = registro.id;
        this.vativo              = registro.ativo;
        this.vtptransp           = registro.tptransp;
        this.vdtcadastro         = registro.dtcadastro;
        this.vrazao              = registro.razao;
        this.vfantasia           = registro.fantasia;
				this.vcep                = registro.cep;
				this.vlogradouro         = registro.logradouro;
				this.vnrendereco         = registro.nrendereco;
				this.vreferencia         = registro.referencia;
				this.vidbairro           = registro.idbairro;
				this.vidmunicipio        = registro.idmunicipio;
				this.viduf               = registro.iduf;
				this.vcnpjcpf            = registro.cnpjcpf;
        this.vrginsc             = registro.rginsc;
        this.vinscmun            = registro.inscmun;
        this.vdtfundacao         = registro.dtfundacao;
        this.vresponsavel        = registro.responsavel;
        this.vramoatividade      = registro.ramoatividade;
				this.vfone1              = registro.fone1;
				this.vfone2              = registro.fone2
        this.vcelular            = registro.celular;
        this.vcontato            = registro.contato;
				this.vemail              = registro.email;
				this.vsite               = registro.site;
				this.vobs                = registro.obs;

				var defbairro             = new Option(registro.descbairro, registro.idbairro, true, true);
				$('#cbbairro').append(defbairro).trigger('change');

				var defmunic              = new Option(registro.descmunic, registro.idmunicipio, true, true);
				$('#cbmunicipio').append(defmunic).trigger('change');

				var defuf                 = new Option(registro.descuf, registro.iduf, true, true);
				$('#cbuf').append(defuf).trigger('change');
			},
			mtdregistro(){
				let vself  = this;
				let loader = vself.$loading.show();
				let registrocrud = {
					'id'                 : this.vid,
          'ativo'              : this.vativo,
          'tptransp'           : this.vtptransp,
          'dtcadastro'         : this.vdtcadastro,  
          'razao'              : this.vrazao,
          'fantasia'           : this.vfantasia,
					'cep'                : this.vcep.replace(/[^0-9]/g,''),
					'logradouro'         : this.vlogradouro,
					'nrendereco'         : this.vnrendereco,
					'referencia'         : this.vreferencia,
					'idbairro'           : this.vidbairro,
					'idmunicipio'        : this.vidmunicipio,
					'iduf'               : this.viduf,
					'cnpjcpf'            : this.vcnpjcpf.replace(/[^0-9]/g,''),
          'rginsc'             : this.vrginsc.replace(/[^0-9]/g,''),
          'inscmun'            : this.vinscmun.replace(/[^0-9]/g,''),
          'dtfundacao'         : this.vdtfundacao,
          'responsavel'        : this.vresponsavel,
          'ramoatividade'      : this.vramoatividade,
					'fone1'              : this.vfone1.replace(/[^0-9]/g,''),
					'fone2'              : this.vfone2.replace(/[^0-9]/g,''),
          'celular'            : this.vcelular.replace(/[^0-9]/g,''),
          'contato'            : this.vcontato,
					'email'              : this.vemail,
					'site'               : this.vsite,
					'obs'                : this.vobs
				};
				let parametros      = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'rotinacrud'},
					{parametro: 'opcrud',       valor : vself.opcrud},
					{parametro: 'registro',     valor : JSON.stringify(registrocrud)},
					{parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
					{parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
					{parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '002Z.008M.001M' : parseInt(this.opcrud) === 2 ? '002Z.008M.002M' : '002Z.008M.003M'},
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtransportadoras.php');
				retorno.then(function (response) {
					loader.hide();
					if ($.isNumeric(response.data)){
						vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
						vself.pfiltro       = 0;
						vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
						vself.pqtd_paginas  = 1;
						vself.mtdcancelaredicao();
						vself.mtdcarregatransportadoras(1);
					}else{
						let tpret = response.data.substring(0,1);
						switch (tpret) {
							case 'I':
								vself.$toastr.w(response.data.substring(4), 'Atenção!');
								break;
							case 'E': default:
								vself.$toastr.e(response.data.substring(4), 'Erro!');
								break;
						}
					}
				}).catch(function (response) {
					loader.hide();
					vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
				});
			},
			formatacpfcnpj(val) {
				return util.formatacpfcnpj(val);
			},			
			mtdselect2_def(){
				let vself  = this;

				$("#edcep").blur(function(){
					vself.mtdpesquisacep();
				});

				$("#cbbairro").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbbairros',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidbairro = $("#cbbairro").val();
				});

				$("#cbmunicipio").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbmunicipios',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 3,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidmunicipio = $("#cbmunicipio").val();
				});

				$("#cbuf").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbufs',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.viduf = $("#cbuf").val();
				});
			},
			mtdpesquisacep(){				
				let vself = this;
				let cepinf = vself.vcep;
				if ( cepinf != ''){
					if (util.IsCEP(cepinf, '')){
						let loader = vself.$loading.show();
						let parametros = [
							{parametro: 'param1', 		valor: 'consultarcep'},
							{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
							{parametro: 'cep', 			valor: cepinf}
						];
						let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/buscarcep.php');
						retorno.then(function (response) {
							loader.hide();
							if (response.data != '0') {
								var defmun            = new Option(response.data.descmunicipio, response.data.idmunicipio, true, true);
								$('#cbmunicipio').append(defmun).trigger('change');

								var defbai            = new Option(response.data.descbairro, response.data.idbairro, true, true);
								$('#cbbairro').append(defbai).trigger('change');

								var defuf             = new Option(response.data.descuf, response.data.iduf, true, true);
								$('#cbuf').append(defuf).trigger('change');

								vself.vlogradouro     = response.data.logradouro;
								vself.vreferencia     = response.data.complemento;
							}else{
								vself.$toastr.w('CEP inválido ou inexistente!', 'Atenção!');
							}

						}).catch(function (response) {
							loader.hide();
							console.log(response.message);
						});
					}
				}
			},				
		},
		mounted: function () {
			if (util.verificasessao(this)) {
					let vself = this;
					let loader = vself.$loading.show();
					let parametros = [
							{parametro: 'op', valor: 'dadosusuario'},
							{parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
							{parametro: 'idusuario', valor: vself.$store.state.usuario.id}
					];
					let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
					retorno.then(function (response) {
							loader.hide();
							vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
							if (util.opcaousuario('002Z.008M', vself.$store.state.perfilusuario)) {
									$('#pnlista').fadeIn(700);
									vself.mtdexecutapesquisa();
									vself.mtdselect2_def();
							} else {
									vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
									setTimeout(function(){
											util.gotoprincipal();
									},1000);
							}
					}).catch(function (response) {
							loader.hide();
							console.log(response.message);
					});
			}
		},
		computed:{
				validou() {
						return this.vdescricao === '' || this.vcep === '' || this.vidbairro === null ||
										this.vidmunicipio === null || this.viduf === '';
				}
		},
		watch:{
				pagina_atual(val){
						this.mtdcarregatransportadoras(val);
				}
		}
	}
</script>
<style>
	.def-col-cod{
		width: 80px !important;
	}
  .def-col-cnpjcpf{
    width: 150px !important;
  }  
	.def-col-ativo{
		width: 80px !important;
	} 	
	#btclonarperfilusuario{
		cursor: pointer;
		font-weight: bold;
		font-size: 18px;
		position: relative;
		float: right;
		top: 5px;
		transition: .35s;
	}
	#btmarcartodosopusuario{
		font-weight: bold;
		font-size: 18px;
		padding-right: 10px;
		cursor: pointer;
		position: relative;
		float: right;
		top: 5px;
		transition: .35s;
	}
	#btmarcartodosopusuario:hover{
		color: #666666;
		transition: .35s;
	}

	#btmarcartodfiliais{
		font-weight: bold;
		font-size: 18px;
		padding-right: 10px;
		cursor: pointer;
		position: relative;
		float: right;
		top: 5px;
		transition: .35s;
	}
	#btmarcartodfiliais:hover{
		color: #666666;
		transition: .35s;
	}
	#btclonarperfilusuario:hover{
		color: #666666;
		transition: .35s;
	}
</style>